import React, {useState, useEffect} from "react";
import { Button, Paper, TextField, Typography } from '@mui/material';
import { useAuth } from "../../Context/AuthContext";
import Alerta from "../../../components/Alerta";
import { db } from "../../../firebase/firebaseConfig";
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';

const FormularioResumenProducto = ({ infoResumenProducto }) => {
    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [subTitulo, setSubTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición

    useEffect(() => {
        const obtenerResumenProducto = async () => {
          if (!infoResumenProducto) return; // Asegúrate de que haya un inforesumenproducto seleccionado
          try {
            const resumenProductoDoc = await getDoc(doc(db, 'inforesumenproductocalocho', infoResumenProducto));
            if (resumenProductoDoc.exists()) {
                setModoEdicion(true);
                const resumenProductoData = resumenProductoDoc.data();
                setTitulo(resumenProductoData.titulo || '');
                setSubTitulo(resumenProductoData.subTitulo || '');
                setDescripcion(resumenProductoData.descripcion || '');
            } else {
              console.log('No se encontró el documento');
              setModoEdicion(false);
            }
          } catch (error) {
            console.error('Error al obtener el documento:', error);
          }
        };
      
        obtenerResumenProducto();
    }, [infoResumenProducto]); // Asegúrate de que useEffect se ejecute cuando cambie infoResumenProducto
      
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        } else if(e.target.name === 'subtitulo'){
            setSubTitulo(e.target.value);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {

            if(modoEdicion && infoResumenProducto.id){

                // Cambiar el estado de modoEdicion a falso para volver al modo de creación
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar el resumen producto
                setTitulo('');
                setSubTitulo('');
                setDescripcion('');
                infoResumenProducto('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Resumen prodcuto actualizado correctamente' });
            
            } else {                

                // Agregar el resumen del producto a Firestore con la URL de la imagen
                await addDoc(collection(db, 'inforesumenproductocalocho'), {
                    titulo: titulo,
                    subtitulo: subTitulo,
                    descripcion: descripcion,
                    uidUsuario: usuario.uid
                });

                // Limpiar el formulario después de agregar el resumen del producto
                setTitulo('');
                setSubTitulo('');
                setDescripcion('');

                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'Resumen del producto agregado correctamente' });
                setEstadoAlerta(true);
                setAlerta({ tipo: 'error', mensaje: 'Error al agregar el Resumen del producto' });
            }

            // Limpiar el formulario después de agregar el resumen del producto
            setTitulo('');
            setSubTitulo('');
            setDescripcion('');

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar el resumen del producto' });
        }
    }

    return (
        <Paper onSubmit={handleSubmit} component="form" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '95%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
        }}>
            <Typography variant='h5' sx={{ 
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                    fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
                }
            }}>Nuestra lista de videos</Typography>

            <TextField                  
                required
                id="titulo"
                fullWidth
                size="small"
                label="Título del resumen"
                name="titulo"
                value={titulo}
                onChange={handleChange}
                />

            <TextField                  
                required
                fullWidth
                size="small"
                id="subtitulo"
                label="subtitulo"
                name="subtitulo"
                value={subTitulo}
                onChange={handleChange}/>

            <TextField                  
                required
                size="small"
                fullWidth
                id="descripcion"
                multiline
                label="Descripción del resumen"
                name="descripcion"
                value={descripcion}
                onChange={handleChange}/>

            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                fullWidth
                size="small"
                variant="outlined"
            >{infoResumenProducto ? 'Editar resumen' : 'Agregar resumen'}</Button>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Paper>

    );
}

export default FormularioResumenProducto;